import { ReactivationCampaignType } from 'src/services/reactivation.types';

export interface ReactivationCampaignDisplay {
  pageTitle: string;
  badgeLabel: string;
  ctaLabel: string;
  showFreeTrial: boolean;
}

const DEFAULT_DISPLAY: ReactivationCampaignDisplay = {
  pageTitle: 'Your fresh start awaits',
  badgeLabel: '',
  ctaLabel: 'Reactivate subscription',
  showFreeTrial: false,
};

export const getCampaignDisplay = (
  campaignType: ReactivationCampaignType | null | undefined,
  discountPercent?: number | null
): ReactivationCampaignDisplay => {
  switch (campaignType) {
    case ReactivationCampaignType.FREE_MONTH:
      return {
        pageTitle: 'Claim your free month!',
        badgeLabel: '1 Month Free',
        ctaLabel: 'Start my free month',
        showFreeTrial: true,
      };
    case ReactivationCampaignType.DISCOUNT_ROLLOVER: {
      // Only show the percentage when we have a valid number from the BE.
      const hasDiscount = discountPercent != null && !isNaN(discountPercent);
      return {
        pageTitle: hasDiscount
          ? `Don't lose your 30 days free access + Lifetime ${discountPercent}% discount!`
          : "Don't lose your 30 days free access + Lifetime discount!",
        badgeLabel: hasDiscount
          ? `${discountPercent}% Discount + 30 Days Free`
          : '',
        ctaLabel: 'Reactivate with my discount',
        showFreeTrial: false,
      };
    }
    default:
      return DEFAULT_DISPLAY;
  }
};
